import { useContext, useState } from "react";
import { CollapsibleStateContext } from "./CollapsibleStateContext";

export interface CollapsibleStateOptions {
  // A unique id to match the state to its component
  id: string;
  // If true, the state will be stored in the context and will persist between renders
  keepState?: boolean;
  // The default state of the collapsible
  defaultIsOpen?: boolean;
}

export type CollapsibleState = [boolean, (isOpen: boolean) => void];

export const useCollapsibleState = ({
  id,
  keepState = false,
  defaultIsOpen = false
}: CollapsibleStateOptions): CollapsibleState => {
  const isOpenState = useState(defaultIsOpen);
  const {collapsibleState, setCollapsibleState} = useContext(CollapsibleStateContext);

  if (keepState) {
    const setState = (isOpen: boolean) => { setCollapsibleState(id, isOpen); };

    if (collapsibleState[id] === undefined) {
      return [defaultIsOpen, setState];
    }

    return [collapsibleState[id], setState];
  }

  return isOpenState;
};